import React from 'react'
import { AppBar, Grid } from '@material-ui/core'
import { Link } from 'react-router-dom'
import logo from '../../media/intergreens-logo.png'
import { withTranslation } from 'react-i18next'
import fiIcon from '../../media/icons/finland.png'
import ukIcon from '../../media/icons/uk.png'
import i18n from '../../i18n'

class Header extends React.Component {
  componentDidMount () {
    window.addEventListener('scroll', this.resizeHeaderOnScroll)
  }

  resizeHeaderOnScroll () {
    const distanceY = window.pageYOffset || document.documentElement.scrollTop
    const shrinkOn = 150
    const headerEl = document.getElementById('main-header')

    if (distanceY > shrinkOn) {
      headerEl.classList.add('smaller')
    } else {
      headerEl.classList.remove('smaller')
    }
  }

  setLocale (locale) {
    i18n.changeLanguage(locale)
  }

  render () {
    const { t } = this.props
    return (
      <AppBar id='main-header' position='fixed'>
        <Link to='/'>
          <img alt='logo' className='logo' src={logo} />
        </Link>
        <Grid container className='header-container' alignItems='center' justify='flex-end'>
          <Grid container item className='header-links hide-lg' md={10}>
            <Link to='/'>{t('home')}</Link>
            <Link to='/about'>Meistä</Link>
            <Link to='/references'>Referenssit</Link>
            <Link to='/contact'>Ota yhteyttä</Link>
          </Grid>
          <Grid container item className='language-bar' xs={12} sm={2}>
            <img alt='finnish' className='langIcon' src={fiIcon} onClick={() => this.setLocale('fi')} />
            <img alt='english' className='langIcon' src={ukIcon} onClick={() => this.setLocale('en')} />
          </Grid>
        </Grid>
      </AppBar>
    )
  }
}

export default withTranslation()(Header)
